export default "/dist/files/icone_bar.9d9f7ba81137dfa8c0dfc1733a60f6ca.svg";